import React, { Component } from "react";
import { PropTypes } from 'prop-types';
import { ComponentWrapper, SearchInput } from "./styles";
import Tabs from "./Component/Tabs/Tabs";
import Geography from "./Component/Geography/Geography";
import GeminiFilter from "./Component/GeminiFilter/GeminiFilter";
import Organizations from "./Component/Organizations/Organizations";
import Financials from "./Component/Financials/Financials";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {cloneDeep} from 'lodash'
import {moveIntoErrorPosition} from '../../utils/commonUtil';
import {
  charitySearched,
  SearchTerm,
  searchGemini,
  clearAllFilter,
  GeminiSearchTerm,
  clearAllGeminiFilter
} from "../../Epics/Grants/Pages/RecommendGrant/actions";
import { getPrimaryAccount } from "../../utils/sessionUtil";
import {
  charityAgreementSearched,
  grantAgreementSearchTerm,
  grantAgreementGeminiSearchTerm,
  agreementSearchGemini,
  gaClearAllFilters,
  gaClearAllGeminiFilters
} from "../../Epics/Grants/Pages/GrantAgreement/actions";
import {
  charityGrantDashboardSearched,
  grantSearchTerm,
  grantGeminiSearchTerm,
  grantSearchGemini,
  grantsClearAllFilters,
  grantsClearAllGeminiFilters
} from "../../Epics/Grants/Pages/GrantsDashboard/actions";
import { charitySearchDerivedStates } from "../selectors";



let assetsMax = 500000000,
  assetsMin = 0,
  expensesMax = 500000000,
  expensesMin = 0,
  revenueMax = 500000000,
  revenueMin = 0;
const ConfigSearch = [
  {
    tabName: "Geography",
    key: "geography",
    activeState: false,
    componentName: Geography,
    seletedFilter: "0",
    count: 0,
    active: false
  },
  {
    tabName: "Organizations",
    key: "organization",
    activeState: false,
    componentName: Organizations,
    seletedFilter: "1",
    count: 0,
    active: false
  },
  {
    tabName: "Financials",
    key: "financials",
    activeState: false,
    componentName: Financials,
    seletedFilter: "2",
    count: 0,
    active: false
  }
];

const ConfigGemini = [
  {
    tabName: "Filter",
    key: "GeminiFilter",
    activeState: false,
    componentName: GeminiFilter,
    seletedFilter: "0",
    count: 2,
    active: false
  }
];

class CharitySearch extends Component {
  state = {
    currentTab: null,
    activeTab: "",
    geminiValue: "",
    financialSlider: false,
    clearFilters: false,
    noOfEmpEnabled: "",
    finTabCount: 1,
    showMyComponent:cloneDeep(ConfigSearch),
    showGemini: ConfigGemini,
    keysGeo: [],
    keysOrg: [],
    keysFin: [],
    keysGem: [],
    city: "",
    oia: "",
    ein: "",
    states: "",
    zipcode: "",
    charityName: "",
    filterCount: {
      geography: 0,
      organization: 0,
      financials: 0,
      GeminiFilter: 0
    },
    geminiData: {
      GeminiFilter: {
        state: "",
        city: "",
        zipcode: "",
        ein: "",
        oia: ""
      }
    },
    searchItem: "",
    data: {
      from: this.props.counterFrom,
      search_terms: "",
      filters: {
        geography: {
          state: [],
          msa: [],
          city: [],
          radius: 0,
          zip: "",
          county: []
        },
        organization: {
          profile_levels: [],
          ntee_major_codes: [],
          ntee_minor_codes: [],
          subsection_codes: [],
          foundation_codes: [],
          bmf_status: true,
          pub78_verified: true,
          affiliation_type: {
            parent: false,
            subordinate: false,
            independent: false,
            headquarter: false
          },
          specific_exclusions: {
            exclude_revoked_organizations: false,
            exclude_defunct_or_merged_organizations: false
          },
          number_of_employees_range: {
            min: 0,
            max: 3500
          },
          form_types: {
            f990: false,
            f990pf: false,
            required_to_file_990t: false
          },
          audits: {
            a_133_audit_performed: false
          }
        },
        financials: {
          form990_total_revenue: {
            min: 0,
            max: 500000000
          },
          form990_total_expenses: {
            min: 0,
            max: 500000000
          },
          form990_total_assets: {
            min: 0,
            max: 500000000
          }
        }
      }
    }
  };

  onSearch = value => {
    const cloneState = { ...this.state.data };
    cloneState.search_terms = value;
    cloneState.from = 0;
   
    switch (this.props.location.pathname) {
      // For Find Charity
      case "/grants/find-charity":
      case "/grants/recommend":
      this.props.SearchTerm(cloneState.search_terms);
        break;
      case "/grants":
        this.props.grantSearchTerm(cloneState.search_terms);
      
        break;
      // For Grant-Agreement
      case "/grants/grant-agreement":  
        this.props.grantAgreementSearchTerm(cloneState.search_terms);
        break;
      default:
        break;
    }
    setTimeout(()=>{
      moveIntoErrorPosition('.scrollUp');
    },500)

  
    this.setState(
      prevState => ({
        ...prevState,
        data: cloneState,
        financialSlider: true
      }),
      this.apiCall
    );
  };

  onGeminiSearch = value => {

    switch (this.props.location.pathname) {
      // For Find Charity
      case "/grants/find-charity":
      case "/grants/recommend":
      this.props.GeminiSearchTerm(value);
        break;
      case "/grants":
      this.props.grantGeminiSearchTerm(value);       
       break;
      // For Grant-Agreement
      case "/grants/grant-agreement":
      this.props.grantAgreementGeminiSearchTerm(value);
       break;
      default:
        break;
    }

    setTimeout(()=>{
      moveIntoErrorPosition('.scrollUp');
    },500)
   
    this.setState({ charityName: value }, this.geminiApiCall);
  };

  apiCall = () => {
    const updatedData = JSON.parse(JSON.stringify(this.state.data));
    if (!this.state.noOfEmpEnabled) {
      updatedData.filters.organization.number_of_employees_range = undefined;
    }
    if (
      updatedData.filters.financials.form990_total_revenue.min === 500000000 ||
      updatedData.filters.financials.form990_total_expenses.min === 500000000 ||
      updatedData.filters.financials.form990_total_assets.min === 500000000 ||
      this.state.financialSlider
    ) {
      updatedData.filters.financials.form990_total_revenue.max = undefined;
      updatedData.filters.financials.form990_total_expenses.max = undefined;
      updatedData.filters.financials.form990_total_assets.max = undefined;
    }

    const metaData = {
      method: "POST",
      url: `/donor-portal/api/granteeOrg/${
        getPrimaryAccount().userId
      }/searchCharitiesInGuidestar`,
      data: updatedData          
    };
    switch (this.props.location.pathname) {
      // For Find Charity
      case "/grants/find-charity":
      case "/grants/recommend":
        this.props.charitySearched(metaData);
        break;
      case "/grants":
        this.props.charityGrantDashboardSearched(metaData);
        break;
      // For Grant-Agreement
      case "/grants/grant-agreement":
        this.props.charityAgreementSearched(metaData);
        break;
      default:
        break;
    }
  };



  geminiApiCall = () => {
    const { charityName, city, oia, ein, states, zipcode } = this.state;

    let BaseUrl = `/donor-portal/api/granteeOrg/${
      getPrimaryAccount().userId
    }/findCharity?`;

    if (charityName === "") {
      BaseUrl = BaseUrl + `name=&`;
    } else {
      BaseUrl = BaseUrl + `name=${charityName}&`;
    }
    if (city === "") {
      BaseUrl = BaseUrl + `city=&`;
    } else {
      BaseUrl = BaseUrl + `city=${city}&`;
    }
    if (oia === "") {
      BaseUrl = BaseUrl + `interestArea=&`;
    } else {
      BaseUrl = BaseUrl + `interestArea=${oia}&`;
    }
    if (ein === "") {
      BaseUrl = BaseUrl + `ein=&`;
    } else {
      BaseUrl = BaseUrl + `ein=${ein}&`;
    }
    if (states === "") {
      BaseUrl = BaseUrl + `state=&`;
    } else {
      BaseUrl = BaseUrl + `state=${states}&`;
    }
    if (zipcode === "") {
      BaseUrl = BaseUrl + `zip=&`;
    } else {
      BaseUrl = BaseUrl + `zip=${zipcode}&`;
    }

    BaseUrl = BaseUrl.substring("&", BaseUrl.length - 1);

    switch (this.props.location.pathname) {
      case '/grants':
        this.props.grantsDashboardSearchGemini({
          method: "GET",
          url: BaseUrl,
          page: "grantsDashboard",
          canCancel:true
        });
        break;
      case "/grants/grant-agreement":
        this.props.agreementSearchGemini({
          method: "GET",
          url: BaseUrl,
          page: "grantAgreements",
          canCancel:true
        });
        break;
      // for both find charity and recommend charity go to default
      case '/grants/find-charity':
      default:
        this.props.searchGemini({
          method: "GET",
          url: BaseUrl,
          page: "recommendGrant",
          canCancel:true
        });
        break;
    }
  };

  componentDidMount() {
    if (this.props.location.pathname === '/grants') {
      this.setState({ from: this.props.grantcounterFrom });
    } else if (this.props.location.pathname === "/grants/grant-agreement") {
      this.setState({ from: this.props.agreementcounterFrom });
    }
    if(this.props.location.pathname !== '/grants') this.searchInput && this.searchInput.focus();
  }

  componentWillReceiveProps(nextprops) {
    if (
      this.props.counterFrom !== nextprops.counterFrom ||
      this.props.grantcounterFrom !== nextprops.grantcounterFrom ||
      this.props.agreementcounterFrom !== nextprops.agreementcounterFrom
    ) {
      switch (this.props.fromPage) {
        case "GD":
          this.setState(
            prevState => ({
              ...prevState,
              data: {
                ...prevState.data,
                ...prevState.data.from,
                from: nextprops.grantcounterFrom
              }
            }),
            () => {
              this.apiCall();
            }
          );
          break;
        case "GA":
          this.setState(
            prevState => ({
              ...prevState,
              data: {
                ...prevState.data,
                ...prevState.data.from,
                from: nextprops.agreementcounterFrom
              }
            }),
            () => {
              this.apiCall();
            }
          );
          break;
        default:
          this.setState(
            prevState => ({
              ...prevState,
              data: {
                ...prevState.data,
                ...prevState.data.from,
                from: nextprops.counterFrom
              }
            }),
            () => {
              this.apiCall();
            }
          );
      }
    }
  }
  
  handler = () => {
    this.setState({
      showMyComponent: false
    });
  };

  changeTab = (key, index) => {
    if (`${key}` === "GeminiFilter") {
      const showGemini = [...this.state.showGemini];
      showGemini[0].active = !showGemini[0].active;
      this.setState({
        showGemini
      });
    } else {
      const { currentTab } = this.state;
      const newComp = [...this.state.showMyComponent];

      if (currentTab !== null && currentTab === index) {
      newComp[index].active = !newComp[index]?.active;
        
        this.setState({
          currentTab: null,
          activeTab: "",
          showMyComponent: newComp
        });
      } else if (currentTab !== null && currentTab !== index) {
        newComp[currentTab].active = !newComp[currentTab].active;
        newComp[index].active = !newComp[index].active;

        this.setState({
          currentTab: index,
          activeTab: `${key}`,
          showMyComponent: newComp
        });
      } else {

        if( newComp[index]){
          newComp[index].active = !newComp[index]?.active;

        this.setState({
          currentTab: index,
          activeTab: `${key}`,
          showMyComponent: newComp
        });
      }
    }
    }
  };

  clearState = () => {
    const searchTerm = { ...this.state.data };
    searchTerm.search_terms = "";
    this.setState({ data: searchTerm });
    this.setState(prevState => ({
      keysGeo: [],
      keysOrg: [],
      keysFin: [],
      searchItem: "",
      city: "",
      oia: "",
      ein: "",
      states: "",
      zipcode: "",
      filterCount: {
        geography: 0,
        organization: 0,
        financials: 0,
        GeminiFilter: 0
      },
      data: {
        ...prevState.data,
        ...prevState.data.search_terms,
        search_terms: "",
        filters: {
          geography: {
            state: [],
            msa: [],
            city: [],
            zip: "",
            radius: 0,
            county: []
          },
          organization: {
            profile_levels: [],
            ntee_major_codes: [],
            ntee_minor_codes: [],
            subsection_codes: [],
            foundation_codes: [],
            bmf_status: true,
            pub78_verified: true,
            affiliation_type: {
              parent: false,
              subordinate: false,
              independent: false,
              headquarter: false
            },
            specific_exclusions: {
              exclude_revoked_organizations: false,
              exclude_defunct_or_merged_organizations: false
            },
            number_of_employees_range: {
              min: 0,
              max: 3500
            },
            form_types: {
              f990: false,
              f990pf: false,
              required_to_file_990t: false
            },
            audits: {
              a_133_audit_performed: false
            }
          },
          financials: {
            form990_total_revenue: {
              min: 0,
              max: 500000000
            },
            form990_total_expenses: {
              min: 0,
              max: 500000000
            },
            form990_total_assets: {
              min: 0,
              max: 500000000
            }
          }
        }
      }
    }));
    


    switch (this.props.location.pathname) {
      // For Find Charity
      case "/grants/find-charity":
      case "/grants/recommend":
      this.props.clearAllFilter(this.state.clearFilters);
        break;
      // For Grant-Agreement
      case "/grants/grant-agreement":
        this.props.gaClearAllFilters(this.state.clearFilters);
        break;
       // For Grants  
      case "/grants":
         this.props.grantsClearAllFilters(this.state.clearFilters);
      default:
        break;
    }
  };

  clearGeminiState = () => {
    this.setState(
      prevState => ({
        keysGem: [],
        geminiValue: "",
        charityName: "",
        city: "",
        oia: "",
        ein: "",
        states: "",
        zipcode: "",
        filterCount: {
          geography: 0,
          organization: 0,
          financials: 0,
          GeminiFilter: 0
        },
        geminiData: {
          ...prevState.geminiData,
          GeminiFilter: {
            state: "",
            city: "",
            zipcode: "",
            ein: "",
            oia: "",
            states: ""
          }
        }
      }));

      switch (this.props.location.pathname) {
        // For Find Charity
        case "/grants/find-charity":
        case "/grants/recommend":
        this.props.clearAllGeminiFilter(this.state.clearFilters);
          break;
        // For Grant-Agreement
        case "/grants/grant-agreement":
          this.props.gaClearAllGeminiFilters(this.state.clearFilters);
          break;
         // For Grants  
        case "/grants":
           this.props.grantsClearAllGeminiFilters(this.state.clearFilters);
        default:
          break;
      }
  };

  closeTab = (index, key) => {
    if (key === "GeminiFilter") {
      const newComp = [...this.state.showGemini];
      newComp[index].active = false;

      this.setState({
        showMyComponent: newComp
      });
    } else {
      const newComp = [...this.state.showMyComponent];
      if(newComp[index]) {
        newComp[index].active = false;
      }

      this.setState({
        currentTab: null,
        showGemini: newComp
      });
    }
  };

  changeState = (value, id, key, max) => {
    if (`${key}` === "GeminiFilter") {
      let countGemini = 0;
  
      if (this.state.keysGem.indexOf(id) === -1) {
        this.state.keysGem.push(id);
      } else if (value === undefined || value.length === 0) {
        let index = this.state.keysGem.indexOf(id);
        if (index > -1) {
          this.state.keysGem.splice(index, 1);
        }
      }
      countGemini = this.state.keysGem.length;
      this.setState(prevState => ({
        ...prevState,
        filterCount: {
          ...prevState.filterCount,
          ...prevState.filterCount.geography,
          ...prevState.filterCount.organization,
          ...prevState.filterCount.financials,
          GeminiFilter: countGemini
        },
        geminiData: {
          ...prevState.geminiData,
          [`${key}`]: {
            ...prevState.geminiData.GeminiFilter,
            ...prevState.geminiData.GeminiFilter.state,
            ...prevState.geminiData.GeminiFilter.city,
            ...prevState.geminiData.GeminiFilter.zipcode,
            ...prevState.geminiData.GeminiFilter.ein,
            ...prevState.geminiData.GeminiFilter.oia,
            [`${id}`]: value
          }
        }
      }));
    } else if (`${key}` === "geography") {
      let countGeog = 0;
      if (this.state.keysGeo.indexOf(id) === -1) {
        this.state.keysGeo.push(id);
      } else if (value === undefined || value.length === 0 || value === 0) {
        let index = this.state.keysGeo.indexOf(id);
        if (index > -1) {
          this.state.keysGeo.splice(index, 1);
        }
      }
      countGeog = this.state.keysGeo.length;
      this.setState(
        prevState => ({
          ...prevState,
          filterCount: {
            ...prevState.filterCount,
            ...prevState.filterCount.geography,
            ...prevState.filterCount.organization,
            ...prevState.filterCount.financials,
            geography: countGeog
          },
          data: {
            ...prevState.data,
            ...prevState.data.search_terms,
            filters: {
              ...prevState.data.filters,
              [`${key}`]: {
                ...prevState.data.filters.geography,
                state: [...prevState.data.filters.geography.state],
                msa: [...prevState.data.filters.geography.msa],
                city: [...prevState.data.filters.geography.city],
                ...prevState.data.filters.geography.zip,
                ...prevState.data.filters.geography.radius,
                county: [...prevState.data.filters.geography.county],

                [`${id}`]: value
              }
            }
          }
        }),
        this.apiCall
      );
    } else if (`${key}` === "organization") {
      let countOrgo = 0;
      if (this.state.keysOrg.indexOf(id) === -1) {
        this.state.keysOrg.push(id);
      } else if (
        value === undefined ||
        value.length === 0 ||
        value === false ||
        (value[0] === 0 && value[1] === max)
      ) {
        let index = this.state.keysOrg.indexOf(id);
        if (index > -1) {
          this.state.keysOrg.splice(index, 1);
        }
      }
      countOrgo = this.state.keysOrg.length;

      if (
        `${id}` === "f990" ||
        `${id}` === "f990pf" ||
        `${id}` === "required_to_file_990t"
      ) {
        this.setState(
          prevState => ({
            ...prevState,
            filterCount: {
              ...prevState.filterCount,
              ...prevState.filterCount.geography,
              ...prevState.filterCount.organization,
              ...prevState.filterCount.financials,
              organization: countOrgo
            },
            data: {
              ...prevState.data,
              ...prevState.data.search_terms,
              filters: {
                ...prevState.data.filters,
                [`${key}`]: {
                  ...prevState.data.filters.organization,
                  profile_levels: [
                    ...prevState.data.filters.organization.profile_levels
                  ],
                  ntee_major_codes: [
                    ...prevState.data.filters.organization.ntee_major_codes
                  ],
                  ntee_minor_codes: [
                    ...prevState.data.filters.organization.ntee_minor_codes
                  ],
                  subsection_codes: [
                    ...prevState.data.filters.organization.subsection_codes
                  ],
                  foundation_codes: [
                    ...prevState.data.filters.organization.foundation_codes
                  ],
                  form_types: {
                    ...prevState.data.filters.organization.form_types,
                    ...prevState.data.filters.organization.profile_levels.f990,
                    ...prevState.data.filters.organization.profile_levels
                      .f990pf,
                    ...prevState.data.filters.organization.profile_levels
                      .required_to_file_990t,
                    [`${id}`]: value
                  },
                  audits: {
                    ...prevState.data.filters.organization.audits,
                    ...prevState.data.filters.organization.audits
                      .a_133_audit_performed
                  }
                }
              }
            }
          }),
          this.apiCall
        );
      } else if (`${id}` === "a_133_audit_performed") {
        this.setState(
          prevState => ({
            ...prevState,
            filterCount: {
              ...prevState.filterCount,
              ...prevState.filterCount.geography,
              ...prevState.filterCount.organization,
              ...prevState.filterCount.financials,
              organization: countOrgo
            },
            data: {
              ...prevState.data,
              ...prevState.data.search_terms,
              filters: {
                ...prevState.data.filters,
                [`${key}`]: {
                  ...prevState.data.filters.organization,
                  profile_levels: [
                    ...prevState.data.filters.organization.profile_levels
                  ],
                  ntee_major_codes: [
                    ...prevState.data.filters.organization.ntee_major_codes
                  ],
                  ntee_minor_codes: [
                    ...prevState.data.filters.organization.ntee_minor_codes
                  ],
                  subsection_codes: [
                    ...prevState.data.filters.organization.subsection_codes
                  ],
                  foundation_codes: [
                    ...prevState.data.filters.organization.foundation_codes
                  ],
                  form_types: {
                    ...prevState.data.filters.organization.form_types,
                    ...prevState.data.filters.organization.profile_levels.f990,
                    ...prevState.data.filters.organization.profile_levels
                      .f990pf,
                    ...prevState.data.filters.organization.profile_levels
                      .required_to_file_990t
                  },
                  audits: {
                    ...prevState.data.filters.organization.audits,
                    ...prevState.data.filters.organization
                      .a_133_audit_performed,
                    [`${id}`]: value
                  }
                }
              }
            }
          }),
          this.apiCall
        );
      } else if (
        `${id}` === "exclude_revoked_organizations" ||
        `${id}` === "exclude_defunct_or_merged_organizations"
      ) {
        this.setState(
          prevState => ({
            ...prevState,
            filterCount: {
              ...prevState.filterCount,
              ...prevState.filterCount.geography,
              ...prevState.filterCount.organization,
              ...prevState.filterCount.financials,
              organization: countOrgo
            },
            data: {
              ...prevState.data,
              ...prevState.data.search_terms,
              filters: {
                ...prevState.data.filters,
                [`${key}`]: {
                  ...prevState.data.filters.organization,
                  profile_levels: [
                    ...prevState.data.filters.organization.profile_levels
                  ],
                  ntee_major_codes: [
                    ...prevState.data.filters.organization.ntee_major_codes
                  ],
                  ntee_minor_codes: [
                    ...prevState.data.filters.organization.ntee_minor_codes
                  ],
                  subsection_codes: [
                    ...prevState.data.filters.organization.subsection_codes
                  ],
                  foundation_codes: [
                    ...prevState.data.filters.organization.foundation_codes
                  ],
                  form_types: {
                    ...prevState.data.filters.organization.form_types,
                    ...prevState.data.filters.organization.profile_levels.f990,
                    ...prevState.data.filters.organization.profile_levels
                      .f990pf,
                    ...prevState.data.filters.organization.profile_levels
                      .required_to_file_990t
                  },
                  audits: {
                    ...prevState.data.filters.organization.audits,
                    ...prevState.data.filters.organization.a_133_audit_performed
                  },
                  specific_exclusions: {
                    ...prevState.data.filters.organization.specific_exclusions,
                    ...prevState.data.filters.organization.specific_exclusions
                      .exclude_revoked_organizations,
                    ...prevState.data.filters.organization.specific_exclusions
                      .exclude_defunct_or_merged_organizations,
                    [`${id}`]: value
                  }
                }
              }
            }
          }),
          this.apiCall
        );
      } else if (
        `${id}` === "parent" ||
        `${id}` === "subordinate" ||
        `${id}` === "independent" ||
        `${id}` === "headquarter"
      ) {
        this.setState(
          prevState => ({
            ...prevState,
            filterCount: {
              ...prevState.filterCount,
              ...prevState.filterCount.geography,
              ...prevState.filterCount.organization,
              ...prevState.filterCount.financials,
              organization: countOrgo
            },
            data: {
              ...prevState.data,
              ...prevState.data.search_terms,
              filters: {
                ...prevState.data.filters,
                [`${key}`]: {
                  ...prevState.data.filters.organization,
                  profile_levels: [
                    ...prevState.data.filters.organization.profile_levels
                  ],
                  ntee_major_codes: [
                    ...prevState.data.filters.organization.ntee_major_codes
                  ],
                  ntee_minor_codes: [
                    ...prevState.data.filters.organization.ntee_minor_codes
                  ],
                  subsection_codes: [
                    ...prevState.data.filters.organization.subsection_codes
                  ],
                  foundation_codes: [
                    ...prevState.data.filters.organization.foundation_codes
                  ],
                  form_types: {
                    ...prevState.data.filters.organization.form_types,
                    ...prevState.data.filters.organization.profile_levels.f990,
                    ...prevState.data.filters.organization.profile_levels
                      .f990pf,
                    ...prevState.data.filters.organization.profile_levels
                      .required_to_file_990t
                  },

                  audits: {
                    ...prevState.data.filters.organization.audits,
                    ...prevState.data.filters.organization.a_133_audit_performed
                  },
                  specific_exclusions: {
                    ...prevState.data.filters.organization.specific_exclusions,
                    ...prevState.data.filters.organization.specific_exclusions
                      .exclude_revoked_organizations,
                    ...prevState.data.filters.organization.specific_exclusions
                      .exclude_defunct_or_merged_organizations
                  },
                  affiliation_type: {
                    ...prevState.data.filters.organization.affiliation_type,
                    ...prevState.data.filters.organization.affiliation_type
                      .parent,
                    ...prevState.data.filters.organization.affiliation_type
                      .subordinate,
                    ...prevState.data.filters.organization.affiliation_type
                      .independent,
                    ...prevState.data.filters.organization.affiliation_type
                      .headquarter,
                    [`${id}`]: value
                  }
                }
              }
            }
          }),
          this.apiCall
        );
      } else if (`${id}` === "number_of_employees_range") {
        let valueofmax = 0;
        if (value[1] && value[1] === max ) {
          valueofmax = max;
        } else {
          valueofmax = value[1];
        }
        this.setState(
          prevState => ({
            ...prevState,
            filterCount: {
              ...prevState.filterCount,
              ...prevState.filterCount.geography,
              ...prevState.filterCount.organization,
              ...prevState.filterCount.financials,
              organization: countOrgo
            },
            data: {
              ...prevState.data,
              ...prevState.data.search_terms,
              filters: {
                ...prevState.data.filters,
                [`${key}`]: {
                  ...prevState.data.filters.organization,
                  profile_levels: [
                    ...prevState.data.filters.organization.profile_levels
                  ],
                  ntee_major_codes: [
                    ...prevState.data.filters.organization.ntee_major_codes
                  ],
                  ntee_minor_codes: [
                    ...prevState.data.filters.organization.ntee_minor_codes
                  ],
                  subsection_codes: [
                    ...prevState.data.filters.organization.subsection_codes
                  ],
                  foundation_codes: [
                    ...prevState.data.filters.organization.foundation_codes
                  ],
                  form_types: {
                    ...prevState.data.filters.organization.form_types,
                    ...prevState.data.filters.organization.profile_levels.f990,
                    ...prevState.data.filters.organization.profile_levels
                      .f990pf,
                    ...prevState.data.filters.organization.profile_levels
                      .required_to_file_990t
                  },

                  audits: {
                    ...prevState.data.filters.organization.audits,
                    ...prevState.data.filters.organization.a_133_audit_performed
                  },
                  specific_exclusions: {
                    ...prevState.data.filters.organization.specific_exclusions,
                    ...prevState.data.filters.organization.specific_exclusions
                      .exclude_revoked_organizations,
                    ...prevState.data.filters.organization.specific_exclusions
                      .exclude_defunct_or_merged_organizations
                  },
                  affiliation_type: {
                    ...prevState.data.filters.organization.affiliation_type,
                    ...prevState.data.filters.organization.affiliation_type
                      .parent,
                    ...prevState.data.filters.organization.affiliation_type
                      .subordinate,
                    ...prevState.data.filters.organization.affiliation_type
                      .independent,
                    ...prevState.data.filters.organization.affiliation_type
                      .headquarter
                  },
                  number_of_employees_range: {
                    min: value[0],
                    max: valueofmax
                  }
                }
              }
            }
          }),
          this.apiCall
        );
      } else {
        this.setState(
          prevState => ({
            ...prevState,
            filterCount: {
              ...prevState.filterCount,
              ...prevState.filterCount.geography,
              ...prevState.filterCount.organization,
              ...prevState.filterCount.financials,
              organization: countOrgo
            },
            data: {
              ...prevState.data,
              ...prevState.data.search_terms,
              filters: {
                ...prevState.data.filters,
                [`${key}`]: {
                  ...prevState.data.filters.organization,
                  profile_levels: [
                    ...prevState.data.filters.organization.profile_levels
                  ],
                  ntee_major_codes: [
                    ...prevState.data.filters.organization.ntee_major_codes
                  ],
                  ntee_minor_codes: [
                    ...prevState.data.filters.organization.ntee_minor_codes
                  ],
                  subsection_codes: [
                    ...prevState.data.filters.organization.subsection_codes
                  ],
                  foundation_codes: [
                    ...prevState.data.filters.organization.foundation_codes
                  ],
                  [`${id}`]: value
                }
              }
            }
          }),
          this.apiCall
        );
      }
    } else if (`${key}` === "financials") {
      let countFinan = 0;
      if (this.state.keysFin.indexOf(id) === -1) {
        this.state.keysFin.push(id);
      } else if (value[0] === 0 && value[1] === max) {
        let index = this.state.keysFin.indexOf(id);
        if (index > -1) {
          this.state.keysFin.splice(index, 1);
        }
      }

      let valueofmax = 0;
      if (value[1] === max) {
        valueofmax = max;
      } else {
        valueofmax = value[1];
      }
      switch (id) {
        case "form990_total_assets":
          assetsMin = value[0];
          assetsMax = valueofmax;
          break;
        case "form990_total_expenses":
          expensesMin = value[0];
          expensesMax = valueofmax;
          break;

        case "form990_total_revenue":
          revenueMin = value[0];
          revenueMax = valueofmax;
          break;
        default:
          break;
      }
      countFinan = this.state.keysFin.length;
      this.setState(
        prevState => ({
          ...prevState,
          financialSlider: false,
          filterCount: {
            ...prevState.filterCount,
            ...prevState.filterCount.geography,
            ...prevState.filterCount.organization,
            ...prevState.filterCount.financials,
            financials: countFinan
          },
          data: {
            ...prevState.data,
            ...prevState.data.search_terms,
            filters: {
              ...prevState.data.filters,
              [`${key}`]: {
                ...prevState.data.filters.financials,
                form990_total_assets: {
                  ...prevState.data.filters.financials.form990_total_assets,
                  ...prevState.data.filters.financials.form990_total_assets.min,
                  ...prevState.data.filters.financials.form990_total_assets.max,
                  min: assetsMin,
                  max: assetsMax
                },
                form990_total_expenses: {
                  ...prevState.data.filters.financials.form990_total_expenses,
                  ...prevState.data.filters.financials.form990_total_expenses
                    .min,
                  ...prevState.data.filters.financials.form990_total_expenses
                    .max,
                  min: expensesMin,
                  max: expensesMax
                },
                form990_total_revenue: {
                  ...prevState.data.filters.financials.form990_total_revenue,
                  ...prevState.data.filters.financials.form990_total_revenue
                    .min,
                  ...prevState.data.filters.financials.form990_total_revenue
                    .max,
                  min: revenueMin,
                  max: revenueMax
                }
              }
            }
          }
        }),
        this.apiCall
      );
    }
  };

  geminiFiltersData = data => {
    this.setState(
      {
        city: data.city,
        oia: data.oia,
        ein: data.ein,
        states: data.states,
        zipcode: data.zipcode
      },
      this.geminiApiCall
    );
  };

  sliderStatus = value => {
    this.setState({ noOfEmpEnabled: value });
  };

  render() {
    let {
      showGeminiFilter,
      grantShowGeminiFilter,
      agreementShowGeminiFilter,
      findCharityShowGeminiFilter
    } = this.props;
    switch (this.props.location.pathname) {
      case '/grants':
        showGeminiFilter = grantShowGeminiFilter;
        break;
      case "/grants/grant-agreement":
        showGeminiFilter = agreementShowGeminiFilter;
        break;
      default: {
      }
    }
    return (
      <ComponentWrapper>
        <div>
          {showGeminiFilter ? (
            <>
              <SearchInput
                id="txtCharitySearchByName"
                placeholder="Search by Name"
                aria-label="Name"
                role="textbox"
                onSearch={this.onGeminiSearch}
                value={this.state.geminiValue}
                onChange={e => this.setState({ geminiValue: e.target.value })}
                disabled={this.props.comingSoon}
              />
              <Tabs
                fromPage={this.props.fromPage}
                config={this.state.showGemini}
                changeTab={this.changeTab}
                changeState={this.changeState}
                closeTab={(index, key) => this.closeTab(index, key)}
                filtersValues={this.state.geminiData}
                clearAllFilters={this.clearGeminiState}
                filtersCounts={this.state.filterCount}
                isActive={this.state.activeTab}
                geminiFiltersData={data => this.geminiFiltersData(data)}
                isFull={this.props.isFull}
              />
            </>
          ) : (
            <>
              <SearchInput
                aria-label="Search"
                 id="txtCharitySearch"
                ref={(input) => this.searchInput = input}
                placeholder={this.props.fromPage === "GA" ? "Search by name, region, interest area or EIN." : "Search by Name, Region, Interest Area, EIN" }
                aria-label="Name"
                role="textbox"
                onSearch={this.onSearch}
                disabled={this.props.comingSoon}
                value={this.state.searchItem}
                onChange={e => this.setState({ searchItem: e.target.value })}
              />
              <Tabs
                fromPage={this.props.fromPage}
                config={this.state.showMyComponent}
                changeTab={this.changeTab}
                changeState={this.changeState}
                closeTab={(index, key) => this.closeTab(index, key)}
                filtersValues={this.state.data.filters}
                clearAllFilters={this.clearState}
                filtersCounts={this.state.filterCount}
                isActive={this.state.activeTab}
                isFull={this.props.isFull}
                sliderStatus={this.sliderStatus}
              />
            </>
          )}
        </div>
      </ComponentWrapper>
    );
  }
}

const mapStateToProps = state => ({
...charitySearchDerivedStates(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  charitySearched: data => dispatch(charitySearched(data)),
  SearchTerm: data => dispatch(SearchTerm(data)),
  GeminiSearchTerm: data => dispatch(GeminiSearchTerm(data)),
  searchGemini: data => dispatch(searchGemini(data)),
  grantsDashboardSearchGemini: data => dispatch(grantSearchGemini(data)),
  agreementSearchGemini: data => dispatch(agreementSearchGemini(data)),
  charityAgreementSearched: data => dispatch(charityAgreementSearched(data)),
  charityGrantDashboardSearched: data =>
    dispatch(charityGrantDashboardSearched(data)),
  clearAllFilter: data => dispatch(clearAllFilter(data)),
  gaClearAllFilters: data => dispatch(gaClearAllFilters(data)),
  grantsClearAllFilters: data => dispatch(grantsClearAllFilters(data)),
  grantSearchTerm: data => dispatch(grantSearchTerm(data)),
  grantGeminiSearchTerm: data => dispatch(grantGeminiSearchTerm(data)),
  grantAgreementSearchTerm: data => dispatch(grantAgreementSearchTerm(data)),
  grantAgreementGeminiSearchTerm: data => dispatch(grantAgreementGeminiSearchTerm(data)),
  clearAllGeminiFilter: data => dispatch(clearAllGeminiFilter(data)),
  gaClearAllGeminiFilters: data => dispatch(gaClearAllGeminiFilters(data)),
  grantsClearAllGeminiFilters: data => dispatch(grantsClearAllGeminiFilters(data))
});

CharitySearch.propTypes = {
  GeminiSearchTerm: PropTypes.func,
  SearchTerm: PropTypes.func,
  agreementSearchGemini: PropTypes.func,
  agreementShowGeminiFilter: PropTypes.bool,
  agreementcounterFrom: PropTypes.number,
  charityAgreementSearched: PropTypes.func,
  charityGrantDashboardSearched: PropTypes.func,
  charitySearched: PropTypes.func,
  clearAllFilter: PropTypes.func,
  clearAllGeminiFilter: PropTypes.func,
  counterFrom: PropTypes.number,
  fromPage: PropTypes.string,
  gaClearAllFilters: PropTypes.func,
  gaClearAllGeminiFilters: PropTypes.func,
  grantAgreementGeminiSearchTerm: PropTypes.func,
  grantAgreementSearchTerm: PropTypes.func,
  grantGeminiSearchTerm: PropTypes.func,
  grantSearchTerm: PropTypes.func,
  grantShowGeminiFilter: PropTypes.bool,
  grantcounterFrom: PropTypes.number,
  grantsClearAllFilters: PropTypes.func,
  grantsClearAllGeminiFilters: PropTypes.func,
  grantsDashboardSearchGemini: PropTypes.func,
  history: PropTypes.object,
  isFull: PropTypes.bool,
  location: PropTypes.object,
  match: PropTypes.object,
  searchGemini:PropTypes.func,
  showGeminiFilter:PropTypes.bool,
  staticContext: PropTypes.any,
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CharitySearch)
);
